// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h+goo","chartContainer":"styles_chartContainer__vwkHN","detailsContainer":"styles_detailsContainer__drbcu"};